/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CustomsDocsState {
  NotRequired = "not_required",
  Missing = "missing",
  Uploaded = "uploaded",
  SentToCarrier = "sent_to_carrier",
  Acknowledged = "acknowledged",
}

export function instanceOfCustomsDocsState(value: any): boolean {
  for (const key in CustomsDocsState) {
    if (Object.prototype.hasOwnProperty.call(CustomsDocsState, key)) {
      if (CustomsDocsState[key as keyof typeof CustomsDocsState] === value) {
        return true;
      }
    }
  }
  return false;
}

export function CustomsDocsStateFromJSON(json: any): CustomsDocsState {
  return CustomsDocsStateFromJSONTyped(json, false);
}

export function CustomsDocsStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomsDocsState {
  return json as CustomsDocsState;
}

export function CustomsDocsStateToJSON(value?: CustomsDocsState | null): any {
  return value as any;
}

export function CustomsDocsStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CustomsDocsState {
  return value as CustomsDocsState;
}
